let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2MH6Y")).then(() => parcelRequire('hTP98'));